"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = exports.gql = void 0;
const gql = (_) => {
    throw new Error(`[graphql-utils]: This should have been removed by the babel plugin. Please make sure the babel plugin is configured correctly`);
};
exports.gql = gql;
const DEFAULT_HEADERS_BY_VERB = {
    POST: {
        'Content-Type': 'application/json',
    },
};
const request = async (endpoint, { operationName, variables, fetchOptions }) => {
    // Uses method from fetchOptions.
    // If no one is passed, figure out with via heuristic
    const method = fetchOptions?.method !== undefined
        ? fetchOptions.method.toUpperCase()
        : operationName.endsWith('Query')
            ? 'GET'
            : 'POST';
    const params = new URLSearchParams({
        operationName,
        ...(method === 'GET' && { variables: JSON.stringify(variables) }),
    });
    const body = method === 'POST'
        ? JSON.stringify({
            operationName,
            variables,
        })
        : undefined;
    const url = `${endpoint}?${params.toString()}`;
    const response = await fetch(url, {
        method,
        body,
        ...fetchOptions,
        headers: {
            ...DEFAULT_HEADERS_BY_VERB[method],
            ...fetchOptions?.headers,
        },
    });
    return response.json();
};
exports.request = request;
//# sourceMappingURL=index.js.map